module.exports = __webpack_public_path__ + "static/img/Tom_Papley_desktop.174d816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Papley_desktop.jpg
// module id = Og0j
// module chunks = 0